export enum FlipType {
  Shorter = 'shorter',
  Longer = 'longer',
  Unimportant = 'unimportant',
}
